import React from 'react';
import { M } from '@dashboard-experience/mastodon';

const LoadingOverlay = () => (
  <div
    data-testid='candidate-story-form-loading-overlay'
    className='candidate-story-form-loading-overlay p-4'
  >
    <M.LoadingInline />
  </div>
);

export default LoadingOverlay;
